import { render, staticRenderFns } from "./SelectSchool.vue?vue&type=template&id=0a8841ce&"
import script from "./SelectSchool.vue?vue&type=script&lang=js&"
export * from "./SelectSchool.vue?vue&type=script&lang=js&"
import style0 from "./SelectSchool.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports